import { useEffect, useState } from 'react';
import { beautify } from '../../../helpers/str';

const InputFieldSwitch = (props) => {
    const { config, onChange, defaultValue } = props;
    const [value, setValue] = useState(defaultValue || '');

    useEffect(() => {
        setValue(defaultValue || '');
    }, [defaultValue]);

    const handleChange = (e) => {
        setValue(e.target.checked);
        onChange(e.target.checked, e.target.name);
    };
    return (
        <label className='form-check form-switch form-switch-sm  form-check-custom form-check-solid'>
            <input
                checked={value && value !== 'false'}
                className='form-check-input'
                type='checkbox'
                value={true}
                name={config.name}
                onChange={handleChange}
            />
            {config.hideLabel !== true && (
                <span className='form-check-label fw-semibold text-muted'>
                    {config.label || beautify(config.name)}
                </span>
            )}
        </label>
    );
};

export default InputFieldSwitch;
